import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  icon: LucideIcon;
  iconColor: string;
  label: string;
  value: string | number;
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  icon: Icon,
  iconColor,
  label,
  value,
  className = "",
}) => {
  return (
    <Card className={`overflow-hidden border border-gray-100 shadow-sm bg-white ${className}`}>
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <Icon className={`h-4 w-4 ${iconColor}`} />
          <p className="font-medium text-gray-600" style={{ fontSize: '13px' }}>
            {label}
          </p>
        </div>
        <p className={`text-2xl font-bold ${iconColor}`}>
          {value}
        </p>
      </CardContent>
    </Card>
  );
}; 